import { countries } from '@common/translate/countries/nlCountries';
import { getSelectedLanguage } from '@frontend/translate';

const countryKeys = Object.keys(countries) as Array<keyof typeof countries>;

export function isCountryKey(key: string | undefined | null) {
    return countryKeys.includes(key as keyof typeof countries);
}

export function getCountryName(key: string | undefined | null): string {
    return isCountryKey(key) ? countries[key as keyof typeof countries] : '';
}

export function getCountryOptions() {
    return Object.entries(getSelectedLanguage().Countries)
        .map((country) => ({
            label: country[1],
            value: country[0],
        }))
        .sort((a, b) => a.label.localeCompare(b.label));
}

export function getCountryCodes() {
    return {
        ...Object.keys(countries).reduce(
            (acc, cur) => ({
                ...acc,
                [cur]: cur,
            }),
            {}
        ),
    } as {
        [k in keyof typeof countries]: k;
    };
}
